<div class="z-40 text-app-text shadow-sm" [ngClass]="{ 'dark text-white-dark': store.semidark && store.menu === 'horizontal'}">
  <div class="theme-header-bg theme-header-text relative flex w-full items-center px-5 py-2.5">
    <div class="horizontal-logo flex items-center justify-between lg:hidden ltr:mr-2 rtl:ml-2">
      <a routerLink="/" class="main-logo flex shrink-0 items-center">
        <img class="inline w-8 ltr:-ml-1 rtl:-mr-1" [src]="apiUrl+'/'+ this.config?.logo" [alt]="this.config?.company_name" appDynamicFontSize="headerlogo" />
        <span
          class="theme-header-text hidden align-middle font-semibold transition-all duration-300 md:inline ltr:ml-1.5 rtl:mr-1.5"
          appDynamicFontSize="heading"
        >
          {{this.config?.company_name}}
        </span>
      </a>

      <button
        type="button"
        class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:text-[#d0d2d6] dark:hover:bg-dark/60 dark:hover:text-app-hover lg:hidden ltr:ml-2 rtl:mr-2"
        style="
          background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
          color: var(--app-header-text-color, var(--app-header-text-color-default));
        "
        (click)="storeData.dispatch({type: 'toggleSidebar'})"
      >
        <i class="fas fa-bars fa-xl"></i>
      </button>
    </div>

    <div class="flex items-center space-x-1.5 dark:text-[#d0d2d6] sm:flex-1 lg:space-x-2 ltr:ml-auto ltr:sm:ml-0 rtl:mr-auto rtl:space-x-reverse sm:rtl:mr-0">
      <div class="sm:ltr:mr-auto sm:rtl:ml-auto">
        <!-- <button
          type="button"
          class="search_btn rounded-full bg-white-light/40 p-4 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60 sm:hidden"
          style="
            background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
            color: var(--app-header-text-color, var(--app-header-text-color-default));
          "
          (click)="search = !search">
          <i
            class="fa-solid fa-magnifying-glass mx-auto dark:text-[#d0d2d6]"></i>
        </button> -->
      </div>

      @if (companyList && companyList.length > 1) {
      <div class="company-dropdown dropdown relative shrink-0 lg:ltr:mr-8 xl:ltr:mr-14 2xl:ltr:mr-20 lg:rtl:ml-8 xl:rtl:ml-14 2xl:rtl:ml-20">
        <button
          type="button"
          class="flex max-w-[300px] items-center gap-2 rounded-full bg-white-light/40 px-3.5 py-2.5 text-sm font-semibold hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60"
          style="
            background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
            color: var(--app-header-text-color, var(--app-header-text-color-default));
          "
          (click)="toggleCompanyMenu($event)"
        >
          <i class="fa-regular fa-building h-5 w-5 text-center text-sm"></i>
          <span class="hidden max-w-[200px] truncate sm:inline">{{ selectedCompanyName || 'Company' }}</span>
          <i class="fa-solid fa-chevron-down text-[10px]"></i>
        </button>
        @if (showCompanyMenu) {
        <ul
          @toggleAnimation
          class="company-dropdown-menu absolute top-12 grid w-[420px] gap-2 rounded-md bg-white !px-2 py-2 font-semibold text-dark shadow-lg dark:bg-[#1b2e4b] dark:text-white-dark dark:text-white-light/90 ltr:-right-14 sm:ltr:-right-2 rtl:-left-14 sm:rtl:-left-2"
        >
          @for (group of groupedCompanyList; track group.key) {
          <li class="company-group-block">
            <div class="company-group-label">{{ group.label }}</div>
            <div class="company-group-list">
              @for (company of group.companies; track company.id) {
              <button
                type="button"
                class="company-menu-item"
                [ngClass]="{ 'bg-primary/10 text-primary': company.id == companyId }"
                (click)="changeCompany(company)"
              >
                <i class="fa-regular fa-building company-menu-icon"></i>
                <span class="company-menu-copy">
                  <span class="company-menu-name">{{ company.name }}</span>
                  @if (getCompanyTenantLabel(company)) {
                  <span class="company-menu-sub">{{ getCompanyTenantLabel(company) }}</span>
                  }
                </span>
                @if (company.code) {
                <span class="company-menu-code">{{ company.code }}</span>
                }
              </button>
              }
            </div>
          </li>
          }
        </ul>
        }
      </div>
      }

      <div>
        <div class="flex items-center space-x-2">
          <div class="notification-dropdown relative">
            <button
              (click)="toggleDropdown()"
              type="button"
              class="relative rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60"
              style="background-color: var(--app-header-bg-color); color: var(--app-header-text-color)"
            >
              <i class="fa-regular fa-bell"></i>

              <span class="absolute right-0 top-0 flex h-3 w-3">
                <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-75"></span>
                <span class="relative inline-flex h-2 w-2 rounded-full bg-success"></span>
              </span>
            </button>
            @if (showNotifications) {
            <div
              class="notification-dropdown-box"
              [class.notification-dropdown-box-mobile]="isMobileView()"
              [style.--notification-panel-top]="notificationPanelTop + 'px'"
            >
              <!-- Tabs -->
              <div class="notification-tabs">
                <div>
                  @for (tab of tabs; track tab.key) {
                  <div
                    (click)="selectTab(tab)"
                    [class.active]="activeTab.key === tab.key"
                    [ngClass]="{
      'opacity-50 pointer-events-none !cursor-not-allowed': loadingNotificationData,
      'cursor-pointer': !loadingNotificationData
    }"
                  >
                    <i [class]="tab.icon"></i>
                    {{ tab.key | translate }}
                  </div>
                  }
                </div>
              </div>
              <div class="notification-tab-content flex w-full flex-col items-center">
                @if (!loadingNotificationData && notifications.length > 0 && activeTab.key === 'push_notification') {
                <div class="flex w-full items-center justify-end border-b border-gray-200 px-3 pb-1">
                  <button
                    class="text-xs hover:opacity-80 disabled:opacity-50"
                    [style.color]="'var(--app-header-bg-color)'"
                    (click)="markPushNotificationAsread()"
                  >
                    {{ 'mark_all_as_read' | translate }}
                  </button>
                </div>
                } @if (loadingNotificationData) {
                <div class="flex w-full items-center justify-center py-6">
                  <div
                    class="h-6 w-6 animate-spin rounded-full border-2"
                    style="
                      border-left-color: var(--app-header-bg-color);
                      border-right-color: var(--app-header-bg-color);
                      border-bottom-color: var(--app-header-bg-color);
                      border-top-color: transparent;
                    "
                  ></div>
                </div>
                } @else if (notifications.length === 0) {
                <div class="flex w-full flex-col items-center justify-center py-10 text-gray-500">
                  <i class="fa fa-bell-slash mb-2 text-3xl"></i>
                  <p class="text-sm">{{'no_notifications' | translate}}s</p>
                </div>
                } @else { @for (item of notifications; track item.id) {
                <!-- <div class="w-full p-3 border-b border-gray-200">
                    <div class="flex justify-between items-start">
                      <p class="font-medium text-gray-800">
                        {{ item.notification_content }}
                      </p>
                      <span class="text-xs text-gray-500" [class.text-blue-600]="item.notify_status === 'Unread'">
                        {{ formatDateTime(item.sent_at) }}
                      </span>
                    </div>
                  </div> -->
                <div class="w-full border-b border-gray-200 p-3">
                  <div class="flex w-full items-start">
                    <!-- LEFT -->
                    <div class="w-[70%] pr-0" [attr.title]="item.notification_content">
                      <p class="line-clamp-2 font-medium text-gray-800">
                        {{ item.notification_content?.length > 200 ? (item.notification_content | slice:0:200) + '...' : item.notification_content }}
                      </p>
                    </div>
                    <!-- RIGHT -->
                    <div class="w-[30%] text-right">
                      <span class="text-xs text-gray-500" [class.text-blue-600]="item.notify_status === 'Unread'"> {{ formatDateTime(item.sent_at) }} </span>
                    </div>
                  </div>
                </div>
                }
                <div class="flex items-center justify-center border-t border-gray-200 px-4 pt-2">
                  <button
                    (click)="navigateToNotifications()"
                    class="flex items-center gap-2 text-sm hover:opacity-80"
                    style="color: var(--app-header-bg-color)"
                  >
                    <i class="fa fa-eye"></i>
                    {{ 'view_all' | translate }}
                  </button>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>

      <div>
        @if (store.theme === 'light') {
        <button
          type="button"
          class="flex items-center rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60"
          style="
            background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
            color: var(--app-header-text-color, var(--app-header-text-color-default));
          "
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'dark'})"
        >
          <i class="far fa-sun ng-tns-c946920775-62 h-5 w-5 text-center text-sm"></i>
        </button>
        } @if (store.theme === 'dark') {
        <button
          type="button"
          class="flex items-center rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60"
          style="
            background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
            color: var(--app-header-text-color, var(--app-header-text-color-default));
          "
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'system'})"
        >
          <i class="far fa-moon ng-tns-c946920775-62 h-5 w-5 text-center text-sm"></i>
        </button>
        } @if (store.theme === 'system') {
        <button
          type="button"
          class="flex items-center rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60"
          style="
            background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
            color: var(--app-header-text-color, var(--app-header-text-color-default));
          "
          (click)="storeData.dispatch({type: 'toggleTheme', payload:'light'})"
        >
          <i class="fas fa-laptop ng-tns-c946920775-62 h-5 w-5 text-center text-sm"></i>
        </button>
        }
      </div>

      <div class="language-dropdown dropdown relative shrink-0">
        <button
          type="button"
          class="block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-app-hover dark:bg-dark/40 dark:hover:bg-dark/60"
          style="
            background-color: var(--app-header-bg-color, var(--app-header-bg-color-default));
            color: var(--app-header-text-color, var(--app-header-text-color-default));
          "
          (click)="toggleLanguageMenu($event)"
        >
          <img [src]="'assets/images/flags/'+ store.locale.toUpperCase() + '.svg'" alt="flag" class="h-5 w-5 rounded-full object-cover" />
        </button>
        @if (showLanguageMenu) {
        <ul
          @toggleAnimation
          class="absolute top-11 z-20 grid w-[280px] grid-cols-2 gap-2 rounded-md bg-white !px-2 py-2 font-semibold text-dark shadow-lg dark:bg-[#1b2e4b] dark:text-white-dark dark:text-white-light/90 ltr:-right-14 sm:ltr:-right-2 rtl:-left-14 sm:rtl:-left-2"
        >
          @for (item of store.languageList; track item.code) {
          <li>
            <button
              type="button"
              class="w-full rounded px-2 py-2 text-left hover:text-primary"
              [ngClass]="{ 'bg-primary/10 text-primary': translate.currentLang === item.code }"
              (click)="changeLanguage(item)"
            >
              <img class="inline h-5 w-5 rounded-full object-cover" [src]="'assets/images/flags/'+ item.code.toUpperCase() + '.svg'" alt />
              <span class="ltr:ml-3 rtl:mr-3">{{ item.name }}</span>
            </button>
          </li>
          }
        </ul>
        }
      </div>

      <!-- <div class="dropdown shrink-0">
          <div hlMenu>
            <button
              type="button"
              hlMenuButton
              class="relative block rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-primary dark:bg-dark/40 dark:hover:bg-dark/60"
              style="background-color: var(--app-header-bg-color, var(--app-header-bg-color-default)); color: var(--app-header-text-color, var(--app-header-text-color-default))"
              >
              <i class="fa-regular fa-bell ng-tns-c946920775-62 h-5 w-5 text-center text-sm"></i>
              <span class="absolute top-0 flex h-3 w-3 ltr:right-0 rtl:left-0">
                <span
                  class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 ltr:-left-[3px] rtl:-right-[3px]"
                ></span>
                <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
              </span>
            </button>
            <ul
              *hlMenuItems
              @toggleAnimation
              class="top-11 w-[300px] divide-y !py-0 text-dark dark:divide-white/10 dark:text-white-dark sm:w-[350px] ltr:-right-2 rtl:-left-2"
              >
              <li>
                <div class="flex items-center justify-between px-4 py-2 font-semibold">
                  <h4 class="text-lg">{{'notifications' | translate}}</h4>
                  <span *ngIf="notifications.length" class="badge bg-primary/80">{{notifications.length + 'New'}}</span>
                </div>
              </li>
              <li *ngFor="let notification of notifications" class="dark:text-white-light/90">
                <div class="group flex items-center px-4 py-2">
                  <div class="grid place-content-center rounded">
                    <div class="relative h-12 w-12 text-center">
                      <i class="fas fa-circle-user fa-xl"></i>
                      <span class="absolute bottom-0 right-[6px] block h-2 w-2 rounded-full bg-success"></span>
                    </div>
                  </div>
                  <div class="flex flex-auto ltr:pl-3 rtl:pr-3">
                    <div class="ltr:pr-3 rtl:pl-3">
                      <h6 [innerHTML]="notification.message"></h6>
                      <span class="block text-xs font-normal dark:text-gray-500">{{notification.time}}</span>
                    </div>
                    <button
                      type="button"
                      class="text-neutral-300 opacity-0 hover:text-danger group-hover:opacity-100 ltr:ml-auto rtl:mr-auto"
                      (click)="$event.stopPropagation();removeNotification(notification.id)"
                      >
                      <i class="fa-solid fa-xmark text-xl"></i>
                    </button>
                  </div>
                </div>
              </li>
              <li *ngIf="notifications.length">
                <div class="p-4">
                  <button type="button" class="btn btn-primary btn-small block w-full" *hlMenuItem="let menuItem">
                    {{'read_all_notifications' | translate}}
                  </button>
                </div>
              </li>
              <li *ngIf="!notifications.length">
                <div class="!grid min-h-[200px] place-content-center text-lg hover:!bg-transparent">
                  <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30"></div>
                  {{'no_data_available'|translate}}
                </div>
              </li>
            </ul>
          </div>
        </div> -->

      <div class="hidden truncate lg:block ltr:pl-4 rtl:pr-4">
        <h4 class="profile-name text-right">{{ profileInfo.name }}</h4>
        <span class="profile-email"> {{ profileInfo.email }} </span>
      </div>

      <div class="profile-dropdown dropdown relative shrink-0">
        <button type="button" class="group relative block" (click)="toggleProfileMenu($event)">
          <img class="h-8 w-8 rounded-full object-cover saturate-50 group-hover:saturate-100" [src]="profileInfo.profile_pic" alt="Profile" />
        </button>
        @if (showProfileMenu) {
        <ul
          @toggleAnimation
          class="absolute top-11 z-20 w-[230px] rounded-md bg-white !py-0 font-semibold text-dark shadow-lg dark:bg-[#1b2e4b] dark:text-white-dark dark:text-white-light/90 ltr:right-0 rtl:left-0"
        >
          <li>
            <div class="flex items-center px-4 py-4">
              <div class="flex-none">
                <img class="h-10 w-10 rounded-md object-cover" [src]="profileInfo.profile_pic" alt="Profile Picture" />
              </div>
              <div class="truncate ltr:pl-4 rtl:pr-4">
                <h4 class="profile-name text-base">{{ profileInfo.name }}</h4>
                <span class="profile-email"> {{ profileInfo.email }} </span>
                <p>{{ profileInfo.role }}</p>
              </div>
            </div>
          </li>
          <li>
            <a routerLink="/profile" class="block px-4 py-2 dark:hover:text-white" (click)="showProfileMenu = false">
              <i class="fa-solid fa-user-tie text-base"></i>&nbsp; {{ "profile" | translate}}
            </a>
          </li>
          <li>
            <a routerLink="/change-password" class="block px-4 py-2 dark:hover:text-white" (click)="showProfileMenu = false">
              <i class="fa-solid fa-unlock-keyhole text-base"></i>&nbsp; {{ "change_password" | translate}}
            </a>
          </li>
          @if (isNativeMobile) {
          <li class="border-t border-white-light dark:border-white-light/10">
            <button
              type="button"
              (click)="toggleBiometricLogin($event)"
              [disabled]="biometricToggleBusy"
              class="flex w-full items-center justify-between px-4 py-2 disabled:opacity-50 dark:hover:text-white"
            >
              <span><i class="fa-solid fa-fingerprint text-base"></i>&nbsp; Fingerprint Login</span>
              <span
                class="relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors"
                [ngClass]="biometricLoginEnabled ? 'bg-primary' : 'bg-gray-300 dark:bg-gray-600'"
              >
                <span
                  class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
                  [ngClass]="biometricLoginEnabled ? 'translate-x-4' : 'translate-x-0.5'"
                ></span>
              </span>
            </button>
          </li>
          }
          <li class="border-t border-white-light dark:border-white-light/10">
            <button type="button" (click)="logout()" class="block w-full !py-3 px-4 text-left text-danger">
              <i class="fa-solid fa-right-from-bracket text-base"></i>&nbsp; {{ "sign_out" | translate}}
            </button>
          </li>
        </ul>
        }
      </div>
    </div>
  </div>

  <!-- horizontal menu -->
  <ul
    class="horizontal-menu theme-header-bg theme-header-text hidden border-t border-[#ebedf2] px-6 py-1.5 font-semibold dark:border-[#191e3a] lg:space-x-1.5 xl:space-x-8 rtl:space-x-reverse"
  >
    <li
      class="menu nav-item relative"
      [class.active]="router.isActive('/', { paths: 'exact', queryParams: 'exact', fragment: 'ignored', matrixParams: 'ignored' })"
    >
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
        <div class="flex items-center">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ng-reflect-ng-class="h-6 w-6"
            class="ng-star-inserted h-6 w-6"
          >
            <path
              opacity="0.5"
              d="M13 15.4C13 13.3258 13 12.2887 13.659 11.6444C14.318 11 15.3787 11 17.5 11C19.6213 11 20.682 11 21.341 11.6444C22 12.2887 22 13.3258 22 15.4V17.6C22 19.6742 22 20.7113 21.341 21.3556C20.682 22 19.6213 22 17.5 22C15.3787 22 14.318 22 13.659 21.3556C13 20.7113 13 19.6742 13 17.6V15.4Z"
              fill="currentColor"
            ></path>
            <path
              d="M2 8.6C2 10.6742 2 11.7113 2.65901 12.3556C3.31802 13 4.37868 13 6.5 13C8.62132 13 9.68198 13 10.341 12.3556C11 11.7113 11 10.6742 11 8.6V6.4C11 4.32582 11 3.28873 10.341 2.64437C9.68198 2 8.62132 2 6.5 2C4.37868 2 3.31802 2 2.65901 2.64437C2 3.28873 2 4.32582 2 6.4V8.6Z"
              fill="currentColor"
            ></path>
            <path
              d="M13 5.5C13 4.4128 13 3.8692 13.1713 3.44041C13.3996 2.86867 13.8376 2.41443 14.389 2.17761C14.8024 2 15.3266 2 16.375 2H18.625C19.6734 2 20.1976 2 20.611 2.17761C21.1624 2.41443 21.6004 2.86867 21.8287 3.44041C22 3.8692 22 4.4128 22 5.5C22 6.5872 22 7.1308 21.8287 7.55959C21.6004 8.13133 21.1624 8.58557 20.611 8.82239C20.1976 9 19.6734 9 18.625 9H16.375C15.3266 9 14.8024 9 14.389 8.82239C13.8376 8.58557 13.3996 8.13133 13.1713 7.55959C13 7.1308 13 6.5872 13 5.5Z"
              fill="currentColor"
            ></path>
            <path
              opacity="0.5"
              d="M2 18.5C2 19.5872 2 20.1308 2.17127 20.5596C2.39963 21.1313 2.83765 21.5856 3.38896 21.8224C3.80245 22 4.32663 22 5.375 22H7.625C8.67337 22 9.19755 22 9.61104 21.8224C10.1624 21.5856 10.6004 21.1313 10.8287 20.5596C11 20.1308 11 19.5872 11 18.5C11 17.4128 11 16.8692 10.8287 16.4404C10.6004 15.8687 10.1624 15.4144 9.61104 15.1776C9.19755 15 8.67337 15 7.625 15H5.375C4.32663 15 3.80245 15 3.38896 15.1776C2.83765 15.4144 2.39963 15.8687 2.17127 16.4404C2 16.8692 2 17.4128 2 18.5Z"
              fill="currentColor"
            ></path>
          </svg>
          <span class="theme-header-text px-2">{{ 'dashboard' | translate }}</span>
        </div>
      </a>
    </li>
    @for (item of menuItems; track item.id; let i = $index) { @if ([COMMON_CONFIG.MENU_LINK_TYPE.ACTION,
    COMMON_CONFIG.MENU_LINK_TYPE.HIDDEN].indexOf(item.link_type) === -1) {
    <li class="menu nav-item relative">
      @if (item.link_type === COMMON_CONFIG.MENU_LINK_TYPE.EXTERNAL) {
      <a [attr.href]="item.target || null" class="nav-link" [attr.target]="item.target ? '_blank' : null" [class.active]="item.isActive">
        <div class="flex items-center">
          <i class="fas" [ngClass]="item.menu_img" aria-hidden="true"></i>
          <span class="theme-header-text px-2">{{item.name | translate}}</span>
        </div>
        @if (hasVisibleChildren(item)) {
        <div class="right_arrow">
          <i class="fa-solid fa-angle-down"></i>
        </div>
        }
      </a>
      } @else {
      <a [routerLink]="item.target ? [item.target] : null" class="nav-link" [class.active]="item.isActive">
        <div class="flex items-center">
          <i class="fas" [ngClass]="item.menu_img" aria-hidden="true"></i>
          <span class="theme-header-text px-2"> {{ item.name | translate }} </span>
        </div>
        @if (hasVisibleChildren(item)) {
        <div class="right_arrow">
          <i class="fa-solid fa-angle-down"></i>
        </div>
        }
      </a>
      } @if (hasVisibleChildren(item)) {
      <ul class="sub-menu custom-min-width">
        @for (child of item.children; track child.id) { @if ([COMMON_CONFIG.MENU_LINK_TYPE.ACTION, COMMON_CONFIG.MENU_LINK_TYPE.HIDDEN].indexOf(child.link_type)
        === -1) {
        <li class="menu nav-item relative" [class.active]="child.isActive">
          @if (child.link_type === COMMON_CONFIG.MENU_LINK_TYPE.EXTERNAL) {
          <a [attr.href]="child.target || null" [attr.target]="child.target ? '_blank' : null" class="nav-link">
            <div class="flex items-center">
              <i class="fas" [ngClass]="child.menu_img" aria-hidden="true"></i>
              <span class="px-2" style="color: var(--app-header-text-color, var(--app-text-color))"> {{ child.name | translate }} </span>
            </div>
            @if (hasVisibleChildren(child)) {
            <div class="right_arrow">
              <i class="fa-solid fa-angle-down"></i>
            </div>
            }
          </a>
          } @else {
          <a [routerLink]="child.target ? [child.target] : null" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
            <div class="flex items-center">
              <i class="fas" [ngClass]="child.menu_img" aria-hidden="true"></i>
              <span class="px-2" style="color: var(--app-header-text-color, var(--app-text-color))"> {{ child.name | translate }} </span>
            </div>
            @if (hasVisibleChildren(child)) {
            <div class="right_arrow">
              <i class="fa-solid fa-angle-down"></i>
            </div>
            }
          </a>
          } @if (hasVisibleChildren(child)) {
          <ul
            class="sub-menu custom-min-width absolute top-0 z-[10] hidden min-w-[180px] rounded bg-white p-0 py-2 text-dark shadow dark:bg-[#1b2e4b] dark:text-white-dark ltr:left-[95%] rtl:right-[95%]"
          >
            @for (childin of child.children; track childin.id) { @if ([COMMON_CONFIG.MENU_LINK_TYPE.ACTION,
            COMMON_CONFIG.MENU_LINK_TYPE.HIDDEN].indexOf(childin.link_type) === -1) {
            <li class="menu nav-item relative" [class.active]="childin.isActive">
              @if (childin.link_type === COMMON_CONFIG.MENU_LINK_TYPE.EXTERNAL) {
              <a [attr.href]="childin.target || null" [attr.target]="childin.target ? '_blank' : null" class="nav-link">
                <div class="flex items-center">
                  <i class="fas" [ngClass]="childin.menu_img" aria-hidden="true"></i>
                  <span class="px-2" style="color: var(--app-header-text-color, var(--app-text-color))"> {{ childin.name | translate }} </span>
                </div>
                @if (hasVisibleChildren(childin)) {
                <div class="right_arrow">
                  <i class="fa-solid fa-angle-down"></i>
                </div>
                }
              </a>
              } @else {
              <a [routerLink]="childin.target ? [childin.target] : null" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
                <div class="flex items-center">
                  <i class="fas" [ngClass]="childin.menu_img" aria-hidden="true"></i>
                  <span class="px-2" style="color: var(--app-header-text-color, var(--app-text-color))"> {{ childin.name | translate }} </span>
                </div>
                @if (hasVisibleChildren(childin)) {
                <div class="right_arrow">
                  <i class="fa-solid fa-angle-down"></i>
                </div>
                }
              </a>
              } @if (hasVisibleChildren(childin)) {
              <ul
                class="sub-menu custom-min-width absolute top-0 z-[10] hidden min-w-[180px] rounded bg-white p-0 py-2 text-dark shadow dark:bg-[#1b2e4b] dark:text-white-dark ltr:left-[95%] rtl:right-[95%]"
              >
                @for (childin3 of childin.children; track childin3.id) { @if ([COMMON_CONFIG.MENU_LINK_TYPE.ACTION,
                COMMON_CONFIG.MENU_LINK_TYPE.HIDDEN].indexOf(childin3.link_type) === -1) {
                <li class="menu nav-item relative" [class.active]="childin3.isActive">
                  @if (childin3.link_type === COMMON_CONFIG.MENU_LINK_TYPE.EXTERNAL) {
                  <a [attr.href]="childin3.target || null" [attr.target]="childin3.target ? '_blank' : null" class="nav-link">
                    <div class="flex items-center">
                      <i class="fas" [ngClass]="childin3.menu_img" aria-hidden="true"></i>
                      <span class="px-2"> {{childin3.name | translate }} </span>
                    </div>
                    @if (hasVisibleChildren(childin3)) {
                    <div class="right_arrow">
                      <i class="fa-solid fa-angle-down"></i>
                    </div>
                    }
                  </a>
                  } @else {
                  <a
                    [routerLink]="childin3.target ? [childin3.target]  : null"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="nav-link"
                  >
                    <div class="flex items-center">
                      <i class="fas" [ngClass]="childin3.menu_img" aria-hidden="true"></i>
                      <span class="theme-header-text px-2"> {{ childin3.name | translate }} </span>
                    </div>
                    @if (hasVisibleChildren(childin3)) {
                    <div class="right_arrow">
                      <i class="fa-solid fa-angle-down"></i>
                    </div>
                    }
                  </a>
                  }
                </li>
                } }
              </ul>
              }
            </li>
            } }
          </ul>
          }
        </li>
        } }
      </ul>
      }
    </li>
    } }
  </ul>
</div>
